"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var NavTabs_1 = __importDefault(require("atomicComponents/atoms/NavTabs/NavTabs"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var HoCs_1 = require("utils/HoCs");
var single_1 = require("utils/selectors/single");
var BenchmarksTable_1 = __importDefault(require("./BenchmarksTable"));
var QuoteAnalyser_1 = __importDefault(require("./QuoteAnalyser"));
var ListReports_1 = __importDefault(require("./QuoteAnalyser/ListReports"));
var saasAuditTabs = [
    { label: 'Benchmarks', href: '/benchmarks' },
    { label: 'Quote Analyser', href: '/benchmarks/quote-analyser' },
];
var Benchmarks = function () {
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [
        { collection: 'quote_analysis_bundles', where: [['userId', '==', profile.id], ['companyId', '==', profile.companyId]] },
    ]; });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Hudled - Benchmarks", description: "Benchmarks" }), (0, jsx_runtime_1.jsx)(NavTabs_1.default, { tabs: saasAuditTabs }), (0, jsx_runtime_1.jsxs)(react_router_dom_1.Switch, { children: [(0, jsx_runtime_1.jsx)(react_router_1.Route, { exact: true, path: "/benchmarks", component: BenchmarksTable_1.default }), (0, jsx_runtime_1.jsx)(react_router_1.Route, { exact: true, path: "/benchmarks/quote-analyser", component: ListReports_1.default }), (0, jsx_runtime_1.jsx)(react_router_1.Route, { exact: true, path: "/benchmarks/quote-analyser/:analysisBundledId/:analysisId?", component: QuoteAnalyser_1.default })] })] }));
};
exports.default = (0, HoCs_1.HasCompanyHoC)(Benchmarks);
